const userInitialState = {
    user: {},
    menu: '',
    sessionRole: '',
    credit: 0,
    urlRedirect: '',
    notifications: {},
    unread_notification: 0,
}
const userReducer = (state = userInitialState, action) => {
    switch (action.type) {
        case 'saveUser':
            return { ...state, user: action.item.user, menu: action.item.menu, sessionRole: action.item.sessionRole, credit: action.item.credit }
        case 'changeMenu':
            return { ...state, menu: action.item.menu }
        case 'updateCredit':
            return { ...state, credit: action.item.credit }
        case 'updateUrlRedirect':
            return { ...state, urlRedirect: action.item.url }
        case 'updateNotification':
            return { ...state, notifications: action.item.notifications, unread_notification: action.item.unread_notification }
        case 'updatePage':
            return { ...state, menu: action.item.menu, sessionRole: action.item.sessionRole }
        default:
            return state
    }
}

export default userReducer;